/* eslint-disable multiline-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  AccessAlarm,
  AccountBox,
  CheckBox,
  Group,
} from '@mui/icons-material';
import {
  DateTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { setSelectedTaskForSchedule } from '../../../redux/app/actions';
import { toMomentValue } from '../../../utils/dateHelper';
import { getBarnUsersForAssignmentString } from '../../../utils/scheduleHelper';
import BarnUsersAutocomplete from '../../Autocompletes/BarnUsers';
import { getBarnHorse } from '../../Schedule/ScheduleTaskItem';
import EditTaskEventData from '../EditTaskEventData';

export const getTaskListTerm = (event) => {
  if (event.horseTask) { return 'Horse'; }
  if (event.barnTask) { return 'Location' }
  return 'Task'
}

export const getTaskStatus = (task) => {
  if (task.archived) return 'Deleted';
  if (task.completeDate) return 'Complete'
  return 'Incomplete'
}

const EditTaskFieldsComponent = ({
  selectedEvent,
  selectedBarn,
  barnHorsesMap,
  dueDate,
  setDueDate,
  validation,
  setValidation,
  completeDate,
  handleCompleteDateChange,
  handleEventDataChange,
  currentStatusAssignment,
  setCurrentStatusAssignment,
  scheduleAssignment,
  handleScheduleAssignmentChange,
}) => {
  const dispatch = useDispatch();

  const [selectedEventBarnHorse, setSelectedEventBarnHorse] = React.useState(null)

  const eventTasks = useSelector((state) => state.schedule.eventTasks)

  React.useEffect(() => {
    if ((!selectedEvent || !selectedEvent.id) && eventTasks && eventTasks.length > 0) {
      dispatch(setSelectedTaskForSchedule(eventTasks[0]))
    }
  }, [eventTasks, selectedEvent])

  React.useEffect(() => {
    if (selectedEvent && selectedEvent.id) {
      const newSelectedEventBarnHorse = getBarnHorse(selectedEvent, null, barnHorsesMap, selectedBarn.barnMetadata.horseTagTypeId)
      setSelectedEventBarnHorse(newSelectedEventBarnHorse);
    } else {
      setSelectedEventBarnHorse(null);
    }
  }, [selectedEvent])

  return (
    <Box>
      <ListItem dense>
        <ListItemIcon><AccountBox /></ListItemIcon>
        <ListItemText>
          <BarnUsersAutocomplete
            label="Task Assignment"
            id="barn-users-task-status-autocomplete-assignment"
            multiple
            size="small"
            value={getBarnUsersForAssignmentString(currentStatusAssignment || '', {})}
            onSelect={(e, newBarnUsers) => {
              // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
              setCurrentStatusAssignment(newBarnUsers.map((bu) => (bu.id
                ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                : `@[${bu.userFullName || bu}](${null})`)).join(''));
            }}
            limitTags={5}
          />
        </ListItemText>
      </ListItem>
      <ListItem dense>
        <ListItemIcon><Group /></ListItemIcon>
        <ListItemText>
          <BarnUsersAutocomplete
            label="Participant(s)"
            id="barn-users-task-participant-autocomplete-assignment"
            multiple
            size="small"
            value={getBarnUsersForAssignmentString(scheduleAssignment || '', {})}
            onSelect={(e, newBarnUsers) => {
              // take selected barn users and map to assignment syntax @[NAME](AUTH0_USER_ID)
              handleScheduleAssignmentChange(newBarnUsers.map((bu) => (bu.id
                ? `@[${bu.userFullName}](${bu.auth0UserId || bu.email})`
                : `@[${bu.userFullName || bu}](${null})`)).join(''));
            }}
            limitTags={5}
          />
        </ListItemText>
      </ListItem>
      {
        !completeDate ? (
          <ListItem dense>
            <ListItemIcon><AccessAlarm /> </ListItemIcon>
            <ListItemText>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Complete Task By"
                  slotProps={{ textField: { size: 'small' } }}
                  value={toMomentValue(dueDate)}
                  onChange={(e) => {
                    const updatedDate = (e && e.toDate) ? e.toDate() : null;
                    if (updatedDate) {
                      setDueDate(updatedDate.getTime() < new Date().getTime()
                        ? new Date()
                        : updatedDate)
                    } else {
                      setDueDate(null);
                    }

                    setValidation({
                      ...validation,
                      hasChanged: true,
                    });
                  }}
                />
              </LocalizationProvider>
            </ListItemText>
          </ListItem>
        ) : (
          <ListItem dense>
            <ListItemIcon><CheckBox /></ListItemIcon>
            <ListItemText>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Completion Date"
                  slotProps={{ textField: { size: 'small' } }}
                  value={toMomentValue(completeDate)}
                  onChange={(e) => {
                    const updatedDate = e.toDate();
                    handleCompleteDateChange(updatedDate)
                  }}
                />
              </LocalizationProvider>
            </ListItemText>
          </ListItem>
        )
      }
      {
        selectedEventBarnHorse && (
          <EditTaskEventData
            taskEventData={selectedEvent.eventData}
            onChange={handleEventDataChange}
            completeDate={completeDate}
            selectedEvent={selectedEvent}
            barnHorse={selectedEventBarnHorse}
            showDivider={false}
            editAtStart
          />
        )
      }
    </Box>

  );
}

EditTaskFieldsComponent.propTypes = {
  selectedEvent: PropTypes.object,
  barnHorsesMap: PropTypes.object,
  selectedBarn: PropTypes.object,
  dueDate: PropTypes.any,
  setDueDate: PropTypes.func,
  validation: PropTypes.object,
  setValidation: PropTypes.func,
  completeDate: PropTypes.any,
  handleCompleteDateChange: PropTypes.func,
  handleEventDataChange: PropTypes.func,
  currentStatusAssignment: PropTypes.any,
  setCurrentStatusAssignment: PropTypes.func,
  scheduleAssignment: PropTypes.string,
  handleScheduleAssignmentChange: PropTypes.func,
};

EditTaskFieldsComponent.defaultProps = {
  selectedEvent: {},
  barnHorsesMap: {},
  selectedBarn: {},
  dueDate: null,
  setDueDate: () => { },
  validation: {},
  setValidation: () => { },
  completeDate: null,
  handleCompleteDateChange: () => { },
  handleEventDataChange: () => { },
  currentStatusAssignment: null,
  setCurrentStatusAssignment: () => { },
  scheduleAssignment: '',
  handleScheduleAssignmentChange: () => { },
};

export default EditTaskFieldsComponent;
